const generateRoot = (level, type, key, component) => name => ({
  name, level, type,
  definition: {
    blocks: [],
    craft: {
      ROOT: {
        type: {
          resolvedName: key,
        },
        isCanvas: true,
        props: {},
        displayName: component,
        custom: {},
        hidden: false,
        nodes: [],
        linkedNodes: {},
      },
    },
  },
})

export const layoutRoot = generateRoot('theme', 'layout', 'layout_root', 'LayoutRootBlock')
export const partialRoot = generateRoot('theme', 'partial', 'partial_root', 'PartialRootBlock')
export const templateRoot = generateRoot('theme', 'template', 'template_root', 'TemplateRootBlock')
